// Helpful links:
// https://documentation.infiniteblue.com/#platform/Currency%20formats.htm
// http://www.londonfx.co.uk/ccylist.html

import Currencies from "@/constants/currencies";

export const CurrencySymbols = {
  [Currencies.USD]: "$",
  [Currencies.EUR]: "€",
  [Currencies.JPY]: "¥",
  [Currencies.GBP]: "£",
  [Currencies.CHF]: "CHF",
  [Currencies.CAD]: "CA$",
  [Currencies.AUD]: "A$",
  [Currencies.NZD]: "NZ$",
  [Currencies.CNY]: "CN¥",
  [Currencies.RUB]: "RUB"
};

export const CurrencyLabels = {
  [Currencies.USD]: "$ (USD)",
  [Currencies.EUR]: "€ (EUR)",
  [Currencies.JPY]: "¥ (JPY)",
  [Currencies.GBP]: "£ (GBP)",
  [Currencies.CHF]: "CHF",
  [Currencies.CAD]: "CA$",
  [Currencies.AUD]: "A$",
  [Currencies.NZD]: "NZ$",
  [Currencies.CNY]: "CN¥",
  [Currencies.RUB]: "RUB"
};

export const CurrencyDecimalPlaces = {
  [Currencies.USD]: 2,
  [Currencies.EUR]: 2,
  [Currencies.JPY]: 0,
  [Currencies.GBP]: 2,
  [Currencies.CHF]: 2,
  [Currencies.CAD]: 2,
  [Currencies.AUD]: 2,
  [Currencies.NZD]: 2,
  [Currencies.CNY]: 2,
  [Currencies.RUB]: 2
};

export function formatCurrency(amount, currency = Currencies.USD) {
  const decimalValue = fromSmallestDenomination(amount, currency);
  return new Intl.NumberFormat("en-US", { style: "currency", currency })
    .format(decimalValue)
    .replace(/\.00$/, "");
}

export function getCleaveMask(currency) {
  return {
    numeral: true,
    numeralDecimalScale: CurrencyDecimalPlaces[currency],
    numeralThousandsGroupStyle: "thousand",
    numeralPositiveOnly: true
  };
}

export function toSmallestDenomination(floatAmount, currency = Currencies.USD) {
  return Math.floor(
    floatAmount * Math.pow(10, CurrencyDecimalPlaces[currency])
  );
}

export function fromSmallestDenomination(
  integerAmount,
  currency = Currencies.USD
) {
  return integerAmount / Math.pow(10, CurrencyDecimalPlaces[currency]);
}
